import { route } from 'preact-router';
import { ntbActionType } from '../../actionTypes';
import { lenderListController } from '../../api/controllers/ntbController';
import { removeBlankKeys } from '../../components/material-ui/helper';
import { addUtmParams } from '../../utils/helper';

export const verifyOTPSuccessActionBic = (responseData) => (dispatch) => {
  const {
    message,
    mobile,
    redirectUrl,
    isNTBEnabledOnMerchant,
    utmSource,
    utmMedium,
    campaignId,
    utmContent,
    utmTerm,
    channel,
    samePage,
  } = responseData || {};

  const data = {
    mobile: mobile,
    redirectUrl: redirectUrl,
  };

  if (!(message === 'success')) {
    const errorMessage = message;
    dispatch({
      type: ntbActionType.VERIFY_OTP_FAILURE,
      payload: { errorMessage },
    });
  } else {
    // dispatch({type: ntbActionType.OPEN_ELIGIBILITY_MODAL, payload: {}});
    dispatch({ type: ntbActionType.LENDER_LIST_REQUEST, payload: {} });
    lenderListController(data)
      .then(({ data: responseData }) => {
        const { eligible, status } = responseData || {};
        dispatch({
          type: ntbActionType.LENDER_LIST_SUCCESS,
          payload: removeBlankKeys({ eligible }),
        });
        dispatch({
          type: ntbActionType.INIT_LENDER_LIST_SCREEN,
          payload: {
            ...responseData,
            mobileNo: mobile,
            redirectUrl: redirectUrl,
            isNTBEnabledOnMerchant,
          },
        });
        dispatch({
          type: ntbActionType.CLOSE_ELIGIBILITY_CHECK_MODAL,
          payload: {},
        });
        dispatch({ type: ntbActionType.CLOSE_OTP_OVERLAY_SCREEN, payload: {} });
        dispatch({ type: ntbActionType.CLOSE_OVERLAY_SCREEN, payload: {} });
        return setTimeout(() => {
          if (
            status === 'REGISTERED' ||
            status === 'PRE_APPROVED' ||
            status === 'ACTIVE'
          ) {
            dispatch({
              type: ntbActionType.OPEN_ELIGIBILITY_MODAL,
              payload: {},
            });
            return dispatch({
              type: ntbActionType.USER_STATUS,
              payload: { userStatus: 'eligible' },
            });
          } else {
            return dispatch({
              type: ntbActionType.USER_STATUS,
              payload: { userStatus: 'notEligible' },
            });
          }
        });
      })
      .catch((error) => {
        dispatch({
          type: ntbActionType.LENDER_LIST_FAILURE,
          payload: removeBlankKeys({ message }),
        });
      });
  }
};



// WEBPACK FOOTER //
// ./actions/ntbAction/verifyOTPSuccessActionBic.js